import { useContext } from "react";
import { Link } from "react-router-dom";

import { AuthContext } from "../../contexts/AuthContext";
import NavbarLink from "../NavbarLink";
import UserProfilePhoto from "../UserProfilePhoto";

import { PencilIcon } from "@heroicons/react/24/outline";
import ASELogo from "../../assets/ase-logo.png";

const PartnerStaffNavbar = () => {
  const { user } = useContext(AuthContext);

  return (
    <nav className="hidden md:flex justify-center py-4 shadow-md">
      <div className="container flex items-center justify-between">
        <Link to="/partner-staff">
          <img src={ASELogo} alt="ASE Group" className="h-[30px]" />
        </Link>

        <div className="flex items-center gap-2">
          <NavbarLink end to="/partner-staff" label="Projects" icon={<PencilIcon className="h-5 w-5 text-ase-blue" />} />

          <Link to="/partner-staff/profile" className="ml-4">
            <UserProfilePhoto
              photoUrl={user?.profilePicture}
              fullName={user?.fullName}
            />
          </Link>
        </div>
      </div>
    </nav>
  );
}

export default PartnerStaffNavbar;
